<script>
    import download from "downloadjs";
    import * as d3 from "d3";
    import {onMount} from "svelte";

    export let DR;
    
    let width = 500;
    let height = 500;
    let margin = 10;
    let r = 2.5;

    export let Y = [];
    export let d;
    export let n;
    
    $: [x, y] = get_scales(Y)
    
    function get_scales(data) {
        let [x_min, x_max] = d3.extent(data, d => d[0]);
        let [y_min, y_max] = d3.extent(data, d => d[1]);
        let [x_span, y_span] = [x_max - x_min, y_max - y_min];
        let offset = Math.abs(x_span - y_span) / 2;
        
        if (x_span > y_span) {
            y_min -= offset;
            y_max += offset;
        } else {
            x_min -= offset;
            x_max += offset;
        }

        return [
            d3.scaleLinear().domain([x_min, x_max]).nice().rangeRound([margin + r, width - (margin + r)]),
            d3.scaleLinear().domain([y_min, y_max]).nice().rangeRound([height - (margin + r), margin + r]),
        ]
    }

</script>
<svg width={width} height={height}>
    {#if DR && n && d}<text x=5 y=5 dominant-baseline="hanging" font-family="Courier Prime">{DR}<tspan dx=12>{n}×{d}</tspan></text>{/if}
    {#if Y}
        <g transform="translate(0, 0)">
            {#each Y as d, i}
                <!-- <circle cx={x(d[0])} cy={y(d[1])} r={r} fill={c(classes[i])}></circle> -->
                <g transform="translate({x(d[0])},{y(d[1])})">
                    <circle r={r} fill="none" stroke="black"></circle>
                </g>
            {/each}
        </g>
    {/if}
</svg>
<hr>